// Generated by ReScript, PLEASE EDIT WITH CARE

import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as Theme__Fonts$PrezzeeRibbon from "../../../theme/Theme__Fonts.bs.js";

var text = BsCssJs$PrezzeeRibbon.style([
      Theme__Fonts$PrezzeeRibbon.SofiaPro.family,
      BsCssJs$PrezzeeRibbon.flexBasis("auto"),
      BsCssJs$PrezzeeRibbon.flexGrow(1),
      BsCssJs$PrezzeeRibbon.flexShrink(1)
    ]);

var Styles = {
  text: text
};

function TheGiftExperience__ListItemText(props) {
  return JsxRuntime.jsx("div", {
              children: props.children,
              className: text
            });
}

var make = TheGiftExperience__ListItemText;

export {
  Styles ,
  make ,
}
/* text Not a pure module */
